import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Field Name `}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Details`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Example`}</strong></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Id`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Unique ID of the Note`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`N000289`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Type`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Type of note`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Comment, Email etc.,`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Created`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Date & Time when the note was added`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`2019-07-16T19:35:55.45+01:00`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`User`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Active username in the account with appropriate access to create note for the employee`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`User name`}</td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      